let timeoutId = null

export function startStoryRequestPoll(courtCaseId) {
  if (timeoutId) stopStoryRequestPoll()
  fetch(`/uk/magistrates/story_requests?court_case_id=${courtCaseId}`)
    .then(response => response.text())
    .then(data => {
      $('.story-request-list').html(data)
      openNewStory(courtCaseId)
    })
    .catch(error => { console.error('Error fetching data:', error) })
    .finally(() => {
      rescheduleTimeout(courtCaseId)
    })
}

export function stopStoryRequestPoll() {
  if (timeoutId) clearTimeout(timeoutId)
}

function openNewStory(courtCaseId) {
  // find details of the most recent request for this court case
  const unparsed = localStorage.getItem('polled_story_requests')
  const storyRequests = JSON.parse(unparsed)
  if (!storyRequests) return
  const caseRequest = storyRequests[`${courtCaseId}`]
  if (!caseRequest) return

  // check if the request has completed i.e. the story is ready
  const requestElement =
    $(`.story-request-item[data-request-id='${caseRequest.id}']`)
  if (!requestElement || requestElement.data('status') !== 'completed') return

  // remove the details from local storage and display the story
  delete storyRequests[`${courtCaseId}`]
  localStorage.setItem('polled_story_requests', JSON.stringify(storyRequests))
  requestElement.click()

  // re-enable the generate story button
  document.getElementById('generate-story-button').classList.remove('disabled')
}

function rescheduleTimeout(courtCaseId) {
  // only reschedule if there is a pending story request
  const pending = $('.story-request-item[data-status=requested]')
  if (pending.length > 0) {
    timeoutId =
      setTimeout(() => startStoryRequestPoll(courtCaseId), 10000)
  }
}
